import { useEffect, useState } from "react";

/**
 * Histórico das últimas cores usadas no editor de texto (pedido do Ricardo,
 * ago/2026: "a última cor que o usuário usou ir ficando salva na barrinha").
 *
 * Fica no localStorage: é preferência de quem está usando o navegador, igual ao
 * toggle de detalhes dos cards. Não vai pro banco — cada pessoa tem a sua.
 *
 * A página pode ter VÁRIOS editores montados ao mesmo tempo (descrição do card,
 * comentário, ajuste…). Escrever no localStorage não avisa os outros, então o
 * registro dispara um evento próprio e cada editor recarrega a lista — senão a
 * cor nova só apareceria na barra onde foi usada, até a próxima remontagem.
 */
const CHAVE = "editor_cores_recentes";
const EVENTO = "cores-recentes-mudou";
const MAX = 6;

function ler(): string[] {
  try {
    const cru = JSON.parse(localStorage.getItem(CHAVE) || "[]");
    if (!Array.isArray(cru)) return [];
    // Só hex de 6 dígitos: é o mesmo formato estrito que o markup aceita, e
    // impede que lixo no localStorage vire um `style` qualquer.
    return cru.filter((c) => typeof c === "string" && /^#[0-9a-f]{6}$/i.test(c)).slice(0, MAX);
  } catch {
    return [];
  }
}

/** Põe a cor no topo do histórico (sem repetir) e avisa os outros editores. */
export function registrarCorUsada(hex: string) {
  if (!/^#[0-9a-f]{6}$/i.test(hex)) return;
  const cor = hex.toLowerCase();
  const nova = [cor, ...ler().filter((c) => c !== cor)].slice(0, MAX);
  try {
    localStorage.setItem(CHAVE, JSON.stringify(nova));
  } catch {
    /* localStorage cheio/bloqueado: o histórico é conveniência, não quebra nada */
  }
  window.dispatchEvent(new Event(EVENTO));
}

export function useCoresRecentes(): string[] {
  const [cores, setCores] = useState<string[]>(ler);
  useEffect(() => {
    const h = () => setCores(ler());
    window.addEventListener(EVENTO, h);
    // `storage` cobre a mesma pessoa com o sistema aberto em duas abas.
    window.addEventListener("storage", h);
    return () => {
      window.removeEventListener(EVENTO, h);
      window.removeEventListener("storage", h);
    };
  }, []);
  return cores;
}
